import React from 'react';
import { Button } from 'antd';
import { useNavigate } from 'react-router-dom';
import { closeEmbeddedMediaViewer } from '@helpers/uxpEmbeddedMediaViewer';
import {
  AlienArrowIcon,
  AlienIcon,
  ErrorPageBigDashedIcon,
  ErrorPageSmallDashedIcon,
  LogoIcon
} from '@icons';
import './ErrorPage.less';

function ErrorPage({
  content,
  buttonCallback,
  buttonCopy = 'Go back'
}: {
  content: any;
  buttonCallback(): void;
  buttonCopy?: string;
}) {
  const navigate = useNavigate();

  return (
    <div className="error-page-container">
      <div className="big-background-round">
        <ErrorPageBigDashedIcon />
      </div>
      <div className="small-background-round">
        <ErrorPageSmallDashedIcon />
      </div>
      <LogoIcon
        className="logo"
        onClick={() => {
          if (closeEmbeddedMediaViewer()) return;
          navigate('/campaigns/all');
        }}
      />
      <div style={{ position: 'relative' }}>
        {content}
        <Button type="primary" className="back-button" onClick={buttonCallback}>
          {buttonCopy}
        </Button>
        <AlienIcon className="alien-icon" />
        <AlienArrowIcon className="alien-arrow-icon" />
      </div>
    </div>
  );
}

export default ErrorPage;
